/**
 * Created by Ning Jiang on 10/10/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";
import {BitmapWinCountUp} from "@nolimitcity/slot-game/bin/game/winpresentation/countup/BitmapWinCountUp";
import {Elastic, Power2, Power3, Timeline, TimelineLite, TweenLite} from "gsap";

export class EdisonBigWinCountUp extends BitmapWinCountUp {

    private _orientation:Orientation = Orientation.LANDSCAPE;
    public static readonly SET_RATIO:string = "EdisonBigWinCountUp_SetRatio";
    private _setYPosTimeline:TimelineLite;
    private _setYPosTween:TweenLite;
    private _currentLevel:number = -1;

    constructor(style:BitmapTextStyleOptions) {
        super(style);

        EventHandler.addEventListener(this, EdisonBigWinCountUp.SET_RATIO, (event:GameEvent) => this.setYPosition(event.params[0]));
        EventHandler.addEventListener(this, SpinEvent.START, (event:GameEvent) => this.onSpinStart());

    }

    public getCountUpAnimation(from:number, to:number, duration:number):Timeline {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            () => {
                this._countUp.alpha = 1;
                this._countUp.visible = true;
            },
            this._countUp.getCountUpAnimation(from, to, {
                duration : duration,
                ease : from == 0 ? Power3.easeInOut : Power2.easeOut
            }),
            TweenLite.fromTo(this._countUpContainer.scale, 1,
                {x : 0.5, y : 0.5},
                {
                    x : 1,
                    y : 1,
                    ease : Elastic.easeOut.config(2, 1)
                })
        ]);

        return timeline;
    }

    protected onResize(resizeData:IResizeData):void {

        if(super.onResize) {
            super.onResize(resizeData);
        }

        this._orientation = resizeData.orientation;

        if(this._setYPosTimeline) {
            this._setYPosTimeline.pause();
            this._setYPosTimeline.kill();
        }

        if(this._orientation === Orientation.LANDSCAPE) {
            if(this._currentLevel === 2)
                this._countUp.position.y = resizeData.height / 5;
            else if(this._currentLevel === -1)
                this._countUp.position.y = 0;
            else {
                this._countUp.position.y = 60;
            }
        } else {
            if(this._currentLevel === 2)
                this._countUp.position.y = resizeData.height / 10;
            else if(this._currentLevel === -1)
                this._countUp.position.y = -100;
            else
                this._countUp.position.y = 0;
        }

    }

    protected getAbortAnimation(endValue:number):Timeline {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            () => {
                this._countUp.alpha = 1;
                this._countUp.visible = true;
            },
            TweenLite.fromTo(this._countUpContainer.scale, 0.2,
                {x : 0.5, y : 0.5},
                {
                    x : 1,
                    y : 1,
                    ease : Elastic.easeOut.config(2, 1)
                }),
            this._countUp.getCountUpAnimation(endValue, endValue, {duration : 0.01})
        ]);
        return timeline;
    }

    public getEndingAnimation(endValue:number):Timeline {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add(this._countUp.getCountUpAnimation(endValue, endValue, {duration : 0.01}));
        //timeline.add(TweenLite.to(this._countUp, 0.2, {alpha : 0}), `+=0.8`); // stay a while after count up.

        return timeline;
    }

    private setYPosition(level:number):void {
        this._currentLevel = level;
        this._setYPosTimeline = new TimelineLite();

        if(this._orientation === Orientation.LANDSCAPE) {
            if(level === 2)
                this._setYPosTimeline.add(() => {
                    this._setYPosTween = TweenLite.to(this._countUp, .5, {y : 130});
                });
            else if(level === -1)
                this._setYPosTimeline.add(() => {
                    this._setYPosTween = TweenLite.to(this._countUp, 1, {y : 0});
                });
            else {
                this._countUp.position.y = 60;
            }
        } else {
            if(level === 2)
                this._setYPosTimeline.add(() => {
                    this._setYPosTween = TweenLite.to(this._countUp, .5, {y : 50});
                });
            else if(level === -1)
                this._setYPosTimeline.add(() => {
                    this._setYPosTween = TweenLite.to(this._countUp, 1, {y : -100});
                });
            else
                this._countUp.position.y = 0;
        }
    }

    private onSpinStart():void {
        TweenLite.to(this._countUp, 0.5, {alpha : 0, delay: 0.8});
    }
}